import {
    CREATE_RESOURCE,
    GET_RESOURCE,
    GET_RESOURCE_BY_ID,
    EDIT_RESOURCE,
    CHANGE_RESOURCE_STATUS,
    DELETE_RESOURCE,
    UPLOAD_RESOURCE_DOCUMENT,
    EDIT_RESOURCE_DOCUMENT,
    GET_RESOURCE_DOCUMENT,
    DELETE_RESOURCE_DOCUMENT,
    EDIT_RESOURCE_ACCESS,
    GET_RESOURCE_ACCESS,
} from './resource.types';

/** Resource */

export const createResource = (body) => {
    return {
        type: CREATE_RESOURCE,
        payload: { body },
    };
};

export const editResource = (id, body) => {
    return {
        type: EDIT_RESOURCE,
        payload: { id, body },
    };
};

export const getResource = (data, load) => {
    return {
        type: GET_RESOURCE,
        payload: { data, load },
    };
};

export const getResourceById = (id) => {
    return {
        type: GET_RESOURCE_BY_ID,
        payload: id,
    };
};

export const changeResourceStatus = (id, status) => {
    return {
        type: CHANGE_RESOURCE_STATUS,
        payload: { id, status },
    };
};
export const deleteResource = (id) => {
    return {
        type: DELETE_RESOURCE,
        payload: id,
    };
};

/** End */

/** Resource Documents */

export const uploadResourceDocument = (file, id) => {
    return {
        type: UPLOAD_RESOURCE_DOCUMENT,
        payload: { file, id },
    };
};

export const editResourceDocument = (id, dockId, file) => {
    return {
        type: EDIT_RESOURCE_DOCUMENT,
        payload: { id, dockId, file },
    };
};

export const getResourceDocument = (id) => {
    return {
        type: GET_RESOURCE_DOCUMENT,
        payload: { id },
    };
};

export const deleteResourceDocument = (resourceId, id) => {
    return {
        type: DELETE_RESOURCE_DOCUMENT,
        payload: { resourceId, id },
    };
};

/** End */

/** Resource Access */

export const editResourceAccess = (id, body) => {
    return {
        type: EDIT_RESOURCE_ACCESS,
        payload: { id, body },
    };
};

export const getResourceAccess = (id) => {
    return {
        type: GET_RESOURCE_ACCESS,
        payload: { id },
    };
};

/** End */
